import { Button, Intent, Popover } from "@blueprintjs/core"
import { ICWProps } from "."
import { __ } from "src/libs/utilities"
import { NAVIGATION_TYPE } from "src/libs/useful/gallery/Gallery"
import { useState } from "react"

/* Protopia Ecosystem component */ 
const NavTypeHandler = (props: ICWProps): JSX.Element => {
    const [ values, ] = useState<NAVIGATION_TYPE[]>( Object.values( NAVIGATION_TYPE).map( val => val ) )
    const onChange = () => {
        const index = values.findIndex(v => v ===  props.carousel_nav) || 0
        const next = (index + 1) % values.length
        props.onChange( {
            ...props,
            carousel_nav: values[next] 
        })
    }
    return <>
         <Button variant="minimal" size="small" className="btn-stretch px-2" onClick={onChange} >
            <div className="small" >
                { __( props.carousel_nav ) }
            </div>
        </Button> 
    </>
}
export default NavTypeHandler